import React, { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getSingleCommonTemplet } from "../../../ReduxStore/Slice/Templets/QuotesTemplets";
import JoditEditor from 'jodit-react';
import { PenLine } from 'lucide-react';

const ReadOnlyCommonTemplate = () => {
    const editor = useRef(null);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const agent_id = JSON.parse(localStorage.getItem("agent_id"));

    const [formData, setFormData] = useState({
        templateName: "",
        body: "",
    });

    useEffect(() => {
        const fetchTemplate = async () => {
            const req = { id: location?.state?.row?.id || location?.state?.id, agent_id };
            await dispatch(getSingleCommonTemplet(req)).unwrap().then((res) => {
                if (res.status) {
                    setFormData({
                        templateName: res.data.name,
                        body: res.data.body,
                    });
                }
            });
        };
        fetchTemplate();
    }, [agent_id, dispatch, location]);

    const config = useMemo(() => ({
        readonly: true,
        toolbar: false,
        showCharsCounter: false,
        showWordsCounter: false,
        showStatusbar: false,
        height: 400,
    }), []);

    return (
        <div className="row mb-4 mt-2">
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header d-sm-flex justify-content-between align-items-center">
                        <h5 className="card-title mb-0">View Common Template</h5>
                        <div className="d-flex">
                            <PenLine
                                className="me-4 cursor-pointer"
                                onClick={() =>
                                    navigate(`/admin/template/edit-common-template`, {
                                        state: { 
                                            id: location?.state?.row?.id || location?.state?.id,
                                            name: formData.templateName,
                                            body: formData.body
                                        },
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="card-body tempaltes">
                        <div className="row mb-4">
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <label className="col-sm-3 col-form-label">Template name:</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={formData.templateName} disabled />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <label className="col-sm-12 col-form-label">Body:</label>
                                    <div className="col-sm-12">
                                        <JoditEditor ref={editor} config={config} value={formData.body || ""} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReadOnlyCommonTemplate;
